/**
 * Facade to interface with the the root component.
 */
var RootComponentFacade = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param signalDisposed The function to invoke to signal that the child was disposed.
     */
    function RootComponentFacade(signalDisposed) {
        this.signalDisposed = signalDisposed;
    }
    return RootComponentFacade;
}());
export { RootComponentFacade };
//# sourceMappingURL=rootComponentFacade.js.map